<!--
 * @Author: George
 * @Description: 高才个人信息表 - 主申请人信息
-->
<template>
    <div v-loading="isLoading">
        <Container title="主申请人" padding="0" id="pdf-user-top">
            <div id="pdf-user">
                <div class="title-box">
                    <span>主申信息</span>
                    <div class="title-btn">
                        <el-button
                            v-if="!isEdit"
                            type="primary"
                            @click="isEdit = true"
                            >编辑</el-button
                        >
                        <el-button v-if="isEdit" @click="cancel"
                            >取消</el-button
                        >
                        <el-button
                            v-if="isEdit"
                            type="primary"
                            :loading="isLoading"
                            @click="saveInfo"
                            >保存</el-button
                        >
                    </div>
                </div>
                <!-- 回显信息 -->
                <UserDetail
                    class="pdf-user-detail"
                    v-if="!isEdit"
                    :selectOptions="selectOptions"
                    :currentItem="currentItem"
                />
                <!-- 编辑 -->
                <User
                    v-if="isEdit"
                    ref="user"
                    :selectOptions="selectOptions"
                    :currentItem.sync="currentItem"
                    :loading.sync="isLoading"
                    @update="updateDetail"
                />
            </div>

          <div slot="handle">
              <el-button v-if="[2, 3].includes(currentItem.application_type)" @click="toDwpAddEducationCertification">提交学位认证需求</el-button>
          </div>
        </Container>
    </div>
</template>

<script>
import User from "./C/EditUser.vue";
import UserDetail from "./C/UserDetail.vue";
import { getComboList } from '../../../../api/gifted'
export default {
    props: {
        info: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    components: {
        User,
        UserDetail,
    },
    data() {
        return {
            isLoading: false,
            isEdit: false,
            selectOptions: {
                identity_plan: [],
                income_category: [],
                income_detail_type: [],
                approval_unit: [],
                exam_types: [],
                is_incubated:[
                    { label: '是', value: 1 },
                    { label: '否', value: 2 },
                ],
                incubation_status: [],
                incubation_project: [],
                incubation_bottleneck: [],
            },
            currentItem: {}, // 主申人信息（编辑&回显共用）
        };
    },
    created() {
        this.getComboList()
        if (this.info.birth_place && !this.info.birth_place.details) {
            this.info.birth_place.details = ''
        }

        if(this.info.identity_plan === 0){
            this.info.identity_plan = ''
        }
        if(this.info.approval_unit === 0){
            this.info.approval_unit = ''
        }
        if(this.info.is_incubated === 0){
            this.info.is_incubated = ''
        }
        if(this.info.incubation_status === 0){
            this.info.incubation_status = ''
        }
        // 初始化 has_approved_stay_hk 字段
        if(this.info.has_approved_stay_hk === null || this.info.has_approved_stay_hk === undefined){
            this.info.has_approved_stay_hk = 0
        }
        // 为空时，初始化相关说明字段
        const fields = ['declaration_first', 'declaration_first_desc', 'declaration_second', 'declaration_second_desc']
        fields.forEach((key) => {
            if (!this.info[key] && this.info[key] != 0) {
                this.info[key] = ''
            }
        })
        this.info.college = Number(this.info.college)
        this.currentItem = JSON.parse(JSON.stringify(this.info))
    },
    methods: {
        async getComboList() {
            const res = await getComboList()
            if(res && res.code === 200) {
                const {
                    approval_unit,
                    exam_types,
                    gaochai_incubation_status,
                    identity_plan,
                    income_categories,
                    income_detail_types,
                    incubation_bottlenecks,
                    youcai_incubation_projects,
                } = res.data
                this.selectOptions.approval_unit = approval_unit || []
                this.selectOptions.exam_types = exam_types || []
                this.selectOptions.incubation_status = gaochai_incubation_status || []
                this.selectOptions.identity_plan = identity_plan || []
                this.selectOptions.income_category = income_categories || []
                this.selectOptions.income_detail_type = income_detail_types || []
                this.selectOptions.incubation_bottleneck = incubation_bottlenecks || []
                this.selectOptions.incubation_project = youcai_incubation_projects || []
            }
        },

      toDwpAddEducationCertification(){
            window.open(`${process.env.VUE_APP_SMARTER_WRITING}/online_submission/education-certification/requirement?order_id=${this.info.order_id}`)
        },
        saveInfo() {
            this.$refs.user?.checkInfo()
        },
        // 更新
        updateDetail() {
            if(this.info.identity_plan === 0){
            this.info.identity_plan = ''
        }
        if(this.info.approval_unit === 0){
            this.info.approval_unit = ''
        }
        if(this.info.is_incubated === 0){
            this.info.is_incubated = ''
        }
        if(this.info.incubation_status === 0){
            this.info.incubation_status = ''
        }
            this.currentItem = JSON.parse(JSON.stringify(this.info))
            this.isEdit = false
        },
        // 取消
        cancel() {
            this.currentItem = JSON.parse(JSON.stringify(this.info))
            this.isEdit = false
        },
    },
};
</script>

<style lang="less" scoped></style>
